import React from 'react';
import './speisekarte.css';
import menuData from '../data/menu.json';

export default function Speisekarte(){
  const MENU = menuData.menu || [];
  return (
    <main className="menu-root">
      <section className="menu-hero">
        <div className="inner">
          <h1>Speisekarte</h1>
          <p className="lead">Unsere Auswahl — frisch zubereitet und perfekt für dein Event.</p>
        </div>
      </section>

      <section className="menu-list">
        {MENU.map((cat)=> (
          <div className="menu-category" key={cat.category}>
            <h2>{cat.category}</h2>
            <div className="items">
              {cat.items.map(it=> (
                <article className="menu-item" key={it.name}>
                  <img src={it.img} alt={it.name} loading="lazy" />
                  <div className="meta">
                    <div className="title-row"><h3>{it.name}</h3><div className="price">{it.price}</div></div>
                    <p className="desc">{it.desc}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        ))}
      </section>
    </main>
  );
}
